const initialState = {
    approved: [], 
    applied:[],
    notoaid:[],
    allapplications:[],
    
  
  };
  
  const FOApplicationReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_APPROVED_SUCCESS':
            return {... state, approved:action.payload};
            case 'FETCH_APPLIED_SUCCESS':
            return {... state, applied:action.payload};
            case 'FETCH_NOTPAID_SUCCESS':
            return {... state, applied:action.payload};
            case 'FETCH_ALL_SUCCESS':
            return {... state, allapplications:action.payload};
            
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default FOApplicationReducers;
  
  